import Types from "Types";
import {
  ActionType,
  createAction,
  createAsyncAction,
  getType,
} from "typesafe-actions";
import { SituationProfessionnelleFormData } from "../../containers/DossierLocation/SituationProfessionnellePage/helpers";
import { SituationProfessionnelle } from "../../services/Api/swagger";

export interface SituationProfessionnelleState {
  situationPro?: SituationProfessionnelleFormData;
  situationProFetching: Types.IFetchInfos;
  listSituationProfessionnelle: SituationProfessionnelle[];
  listSituationProFetching: Types.IFetchInfos;
}

export const initialState: SituationProfessionnelleState = {
  situationPro: undefined,
  situationProFetching: {
    fetching: false,
    error: undefined,
  },
  listSituationProFetching: {
    fetching: false,
    error: undefined,
  },
  listSituationProfessionnelle: [],
};

export const getListSituationProfessionnelleAsync = createAsyncAction(
  "@@App/situationProfessionnelle/LOAD_REQUEST",
  "@@App/situationProfessionnelle/LOAD_SUCCESS",
  "@@App/situationProfessionnelle/LOAD_FAILURE"
)<void, SituationProfessionnelle[], any>();

export const addOrUpdateSituationProfessionnelleAsync = createAction(
  "@@App/situationProfessionnelle/ADD_UPDATE_SUCCESS"
)<SituationProfessionnelleFormData>();

export const removeSituationProfessionnelleError = createAction(
  "@@App/situationProfessionnelle/REMOVE_ERROR"
)<void>();

export const resetSituationProParcoursCreation = createAction(
  "@@App/situationPersonnelle/PARCOURS_CREATION/RESET_STORE"
)<void>();

export const ActionCreators = {
  getListSituationProfessionnelleAsync,
  addOrUpdateSituationProfessionnelleAsync,
  removeSituationProfessionnelleError,
  resetSituationProParcoursCreation,
};

const getSituationProfessionnelle = (
  state: Types.RootState
): SituationProfessionnelleFormData | undefined =>
  state.situationProfessionnelle.situationPro;

const getSituationProfessionnelleFetching = (state: Types.RootState): boolean =>
  state.situationProfessionnelle.situationProFetching.fetching;

const getSituationProfessionnelleError = (
  state: Types.RootState
): Types.IFetchInfos =>
  state.situationProfessionnelle.situationProFetching.error;

const getListSituationProfessionnelle = (
  state: Types.RootState
): SituationProfessionnelle[] =>
  state.situationProfessionnelle &&
  state.situationProfessionnelle.listSituationProfessionnelle;

const getListSituationProFetching = (state: Types.RootState): boolean =>
  state.situationProfessionnelle.listSituationProFetching.fetching;

const getListSituationProError = (state: Types.RootState): boolean =>
  state.situationProfessionnelle.listSituationProFetching.error;

export const Selectors = {
  getSituationProfessionnelle,
  getSituationProfessionnelleError,
  getSituationProfessionnelleFetching,
  getListSituationProfessionnelle,
  getListSituationProFetching,
  getListSituationProError,
};

export const reducer = (
  state: SituationProfessionnelleState = initialState,
  action: ActionType<typeof ActionCreators>
): SituationProfessionnelleState => {
  switch (action.type) {
    case getType(getListSituationProfessionnelleAsync.request):
      return {
        ...state,
        listSituationProFetching: {
          fetching: true,
          error: undefined,
        },
      };

    case getType(getListSituationProfessionnelleAsync.success):
      return {
        ...state,
        listSituationProfessionnelle: action.payload,
        listSituationProFetching: {
          fetching: false,
          error: undefined,
        },
      };
    case getType(getListSituationProfessionnelleAsync.failure):
      return {
        ...state,
        listSituationProFetching: {
          fetching: false,
          error: action.payload,
        },
      };

    case getType(addOrUpdateSituationProfessionnelleAsync):
      return {
        ...state,
        situationPro: action.payload,
        situationProFetching: {
          fetching: false,
          error: undefined,
        },
      };

    case getType(removeSituationProfessionnelleError):
      return {
        ...state,
        situationProFetching: {
          fetching: false,
          error: undefined,
        },
      };
    case getType(resetSituationProParcoursCreation):
      return {
        ...state,
        situationPro: undefined,
        situationProFetching: {
          error: undefined,
          fetching: false,
        },
      };
  }
  return state;
};
